// extracted by mini-css-extract-plugin
export default {"cls1":"NewsHeader-cls1_FKb","cls2":"NewsHeader-cls2_ncc NewsHeader-cls1_FKb"};